import { Select } from '@truepill/react-capsule'
import { ShippingMethod } from 'types'
import { camelCaseToHumanReadable, shippingMethodToName } from 'utils'

const SATURDAY_DELIVERY_SHIPPING_METHODS = [ShippingMethod.UpsNextDayAir, ShippingMethod.UpsSecondDayAir]

type SaturdayDeliverySelectProps = {
  value?: string
  onSelect: (shippingMethod?: ShippingMethod) => void
}

const SaturdayDeliverySelect = ({ value, onSelect }: SaturdayDeliverySelectProps): JSX.Element => {
  const options = SATURDAY_DELIVERY_SHIPPING_METHODS.map(method => ({
    label: camelCaseToHumanReadable(shippingMethodToName[method]),
    value: method as string,
  }))
  const selected = options.find(option => option.value === value) ?? undefined

  return (
    <Select
      label="Saturday delivery eligibility"
      value={selected}
      placeholder="Select shipping method…"
      options={[{ label: 'Select All', value: 'All' }, ...options]}
      selectedKey="label"
      onChange={option => {
        onSelect(!option || option.value === 'All' ? undefined : (option.value as ShippingMethod))
      }}
    />
  )
}

export default SaturdayDeliverySelect
